import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { filter, first, switchMap, takeUntil, tap } from 'rxjs/operators';
import { BaseObject } from '@shared/base/base-object';
import { CatalogService } from '@shared/api/catalog.service';
import { CatalogObject, Category, Dictionaries } from '@shared/types/sketch-catalog';
import { UserState } from './user.state';
import { MAX_CATALOG_ITEMS_PER_PAGE } from '@shared/constants/sketch';

@Injectable({
  providedIn: 'root',
})
export class CatalogState extends BaseObject {
  public products$ = new BehaviorSubject<CatalogObject[]>(null);
  // public projectObjects$ = new BehaviorSubject<CatalogObject[]>([]);
  public customObjects$ = new BehaviorSubject<CatalogObject[]>(null);
  public categories$ = new BehaviorSubject<Category[]>(null);
  // ─── Официальный каталог + кастомные объекты (идут после официальных) ───────
  public allProducts$ = new BehaviorSubject<CatalogObject[]>([]);
  public loading$ = new BehaviorSubject<boolean>(false);
  public dictionaries: Dictionaries;

  constructor(
    private userState: UserState,
    private catalogService: CatalogService,
  ) {
    super();

    this.loading$.next(true);

    this.userState.user$
      .pipe(
        filter((user) => !!user),
        first(),
        switchMap(() =>
          combineLatest([
            this.load({ page: 1, itemsPerPage: MAX_CATALOG_ITEMS_PER_PAGE }),
            this.catalogService.getCategories(),
          ]),
        ),
      )
      .subscribe(([products, categories]) => {
        this.loading$.next(false);
        this.products$.next(products);
        this.categories$.next(categories);
      });

    combineLatest([this.products$, this.customObjects$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([products, customObjects]) => {
        this.allProducts$.next([...(products ?? []), ...(customObjects ?? [])]);
      });
  }

  public load(params: { [key: string]: string | number | boolean }): Observable<CatalogObject[]> {
    return this.catalogService.getCatalog(params);
  }

  // public loadProjectObjects(projectId: number): Observable<CatalogObject[]> {
  //   return this.catalogService
  //     .getProjectObjects(projectId)
  //     .pipe(tap((projectObjects) => this.projectObjects$.next(projectObjects)));
  // }

  public loadCustomObjects(params: {
    [key: string]: string | number | boolean;
  }): Observable<CatalogObject[]> {
    return this.catalogService
      .getCustomObjects(params)
      .pipe(tap((customObjects) => this.customObjects$.next(customObjects)));
  }

  public updateCustomObject(id: number, patch: Partial<CatalogObject>): void {
    this.customObjects$.next(
      (this.customObjects$.value ?? []).map((product) =>
        product.id === id ? { ...product, ...patch } : product,
      ),
    );
  }
}
